<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">

    <!-- Header Section -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">รายการชาร์จรถ EV (EV
                Charger Transactions)
            </h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ตรวจสอบสถานะและประวัติการชาร์จรถยนต์ไฟฟ้า</p>
        </div>

        <div class="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
            <!-- Date Filter -->
            <div
                class="flex items-center gap-2 px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-50 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px] w-full sm:w-auto">
                <span class="material-icons text-slate-400 text-xl">calendar_today</span>

                <div class="relative w-full sm:w-[130px] h-full flex items-center">
                    <div
                        class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
                        <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
                        <span class="material-icons text-slate-400 text-lg">expand_more</span>
                    </div>
                    <input #startDatePicker type="date" [(ngModel)]="startDate" (change)="onDateChange()"
                        [max]="endDate" (click)="startDatePicker.showPicker()"
                        class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
                </div>

                <span class="text-slate-300 dark:text-slate-600">-</span>

                <div class="relative w-full sm:w-[130px] h-full flex items-center">
                    <div
                        class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
                        <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
                        <span class="material-icons text-slate-400 text-lg">expand_more</span>
                    </div>
                    <input #endDatePicker type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
                        (click)="endDatePicker.showPicker()"
                        class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
                </div>
            </div>

            <button (click)="toggleDashboard()"
                class="hidden sm:flex px-4 py-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 items-center gap-2"
                [title]="showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ'">
                <span class="material-icons">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
                <span class="text-sm font-bold">{{ showDashboard ? 'ซ่อนกราฟ' : 'แสดงกราฟ' }}</span>
            </button>

            <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
                <span
                    class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">อัปเดตล่าสุด</span>
                <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime |
                    date:'HH:mm:ss' }}</span>
            </div>

            <label
                class="flex items-center gap-2 px-3 py-2 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 cursor-pointer select-none h-[46px]"
                title="เปิดเพื่อดึงข้อมูลอัตโนมัติทุก 1 นาที">
                <input type="checkbox" [(ngModel)]="enableLiveRefresh" (change)="onLiveRefreshToggle()"
                    class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
                <span class="text-sm font-bold text-slate-600 dark:text-slate-300 whitespace-nowrap">Live (1 นาที)</span>
            </label>

            <button (click)="onRefresh()"
                class="w-full sm:w-auto px-4 py-2 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px]"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
        </div>
    </div>

    <div class="overflow-hidden transition-all duration-500 ease-in-out"
        [style.max-height]="showDashboard ? '2000px' : '0px'" [style.opacity]="showDashboard ? '1' : '0'"
        [style.margin-bottom]="showDashboard ? '2rem' : '0'">
        <!-- Dashboard Cards -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 pt-1" *ngIf="showDashboard">

            <!-- Total Transactions -->
            <div
                class="animate-fade-in stagger-1 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group">
                <div
                    class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-blue-500 opacity-[0.08] dark:opacity-[0.15] group-hover:scale-110 transition-transform">
                </div>
                <div class="relative z-10 flex justify-between items-start mb-4">
                    <div
                        class="w-12 h-12 rounded-2xl bg-blue-50 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400 flex items-center justify-center shadow-sm">
                        <span class="material-icons text-2xl">ev_station</span>
                    </div>
                </div>
                <div class="relative z-10">
                    <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">
                        รายการทั้งหมด</h4>
                    <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{
                        dashboardStats.totalTransactions |
                        number }}</div>
                </div>
            </div>

            <!-- Active Charging -->
            <div
                class="animate-fade-in stagger-2 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group">
                <div
                    class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-amber-500 opacity-[0.08] dark:opacity-[0.15] group-hover:scale-110 transition-transform">
                </div>
                <div class="relative z-10 flex justify-between items-start mb-4">
                    <div
                        class="w-12 h-12 rounded-2xl bg-amber-50 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center shadow-sm">
                        <span class="material-icons text-2xl">bolt</span>
                    </div>
                </div>
                <div class="relative z-10">
                    <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">
                        กำลังชาร์จ</h4>
                    <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{
                        dashboardStats.activeCharging |
                        number
                        }}</div>
                </div>
            </div>

            <!-- Completed -->
            <div
                class="animate-fade-in stagger-3 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group">
                <div
                    class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-emerald-500 opacity-[0.08] dark:opacity-[0.15] group-hover:scale-110 transition-transform">
                </div>
                <div class="relative z-10 flex justify-between items-start mb-4">
                    <div
                        class="w-12 h-12 rounded-2xl bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 flex items-center justify-center shadow-sm">
                        <span class="material-icons text-2xl">check_circle</span>
                    </div>
                </div>
                <div class="relative z-10">
                    <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">
                        ชาร์จเสร็จสิ้น</h4>
                    <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{
                        dashboardStats.completed | number
                        }}
                    </div>
                </div>
            </div>

            <!-- Revenue -->
            <div
                class="animate-fade-in stagger-4 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group">
                <div
                    class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-purple-500 opacity-[0.08] dark:opacity-[0.15] group-hover:scale-110 transition-transform">
                </div>
                <div class="relative z-10 flex justify-between items-start mb-4">
                    <div
                        class="w-12 h-12 rounded-2xl bg-purple-50 dark:bg-purple-900/40 text-purple-600 dark:text-purple-400 flex items-center justify-center shadow-sm">
                        <span class="material-icons text-2xl">payments</span>
                    </div>
                </div>
                <div class="relative z-10">
                    <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">
                        รายได้รวม</h4>
                    <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{
                        dashboardStats.totalRevenue |
                        number:'1.2-2' }}</div>
                </div>
            </div>
        </div>

        <!-- Status Proportion Chart -->
        <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 mb-8" *ngIf="showDashboard" style="animation-delay: 0.15s;">
            <div class="flex items-center justify-between mb-2">
                <h3 class="text-sm font-bold text-slate-800 dark:text-slate-100">สัดส่วนสถานะการชาร์จ (7 วันล่าสุด)</h3>
            </div>
            
            <div class="flex flex-col sm:flex-row items-center justify-center gap-12 py-4">
                <!-- Circle Chart -->
                <div class="relative w-32 h-32 flex-shrink-0 flex items-center justify-center">
                    <svg viewBox="0 0 36 36" class="w-full h-full transform -rotate-90 drop-shadow-sm">
                        <!-- Background Track -->
                        <circle cx="18" cy="18" r="15.5" fill="none" class="stroke-slate-100 dark:stroke-slate-700/50" stroke-width="4"></circle>
                        
                        <!-- Base Track (Completed - Emerald) -->
                        <circle cx="18" cy="18" r="15.5" fill="none" class="stroke-emerald-500 transition-all duration-1000 ease-out" stroke-width="4"
                                pathLength="100"
                                [attr.stroke-dasharray]="completedPct + ' ' + (100 - completedPct)"
                                stroke-dashoffset="0"
                                [class.hidden]="completedPct === 0"></circle>
                        
                        <!-- Active Charging (Blue) -->
                        <circle cx="18" cy="18" r="15.5" fill="none" class="stroke-blue-500 transition-all duration-1000 ease-out" stroke-width="4"
                                pathLength="100"
                                [attr.stroke-dasharray]="activePct + ' ' + (100 - activePct)"
                                [attr.stroke-dashoffset]="-completedPct"
                                [class.hidden]="activePct === 0"></circle>
                        
                        <!-- Waiting (Amber) -->
                        <circle cx="18" cy="18" r="15.5" fill="none" class="stroke-amber-400 transition-all duration-1000 ease-out" stroke-width="4"
                                pathLength="100"
                                [attr.stroke-dasharray]="waitingPct + ' ' + (100 - waitingPct)"
                                [attr.stroke-dashoffset]="-(completedPct + activePct)"
                                [class.hidden]="waitingPct === 0"></circle>
                    </svg>
                    
                    <!-- Inner Text -->
                    <div class="absolute inset-0 flex flex-col items-center justify-center">
                        <span class="text-2xl font-black text-slate-800 dark:text-slate-100 leading-none mb-1">{{ donutStats.totalTransactions }}</span>
                        <span class="text-[9px] font-bold text-slate-400 uppercase tracking-widest leading-none">รวมทั้งหมด</span>
                    </div>
                </div>
                
                <!-- Legend -->
                <div class="flex flex-col gap-4 min-w-[150px]">
                    <!-- Completed -->
                    <div class="flex items-center gap-3">
                        <div class="w-3.5 h-3.5 rounded-full bg-emerald-500 shadow-sm border-2 border-white dark:border-slate-800"></div>
                        <div class="flex flex-col leading-none gap-1">
                            <span class="text-[10px] font-bold text-slate-400">ชาร์จเสร็จสิ้น</span>
                            <div class="flex items-baseline gap-1">
                                <span class="text-sm font-black text-slate-700 dark:text-slate-200">{{ donutStats.completed }}</span>
                                <span class="text-xs font-bold text-slate-400">({{ completedPct | number:'1.0-0' }}%)</span>
                            </div>
                        </div>
                    </div>
                    <!-- Active -->
                    <div class="flex items-center gap-3">
                        <div class="w-3.5 h-3.5 rounded-full bg-blue-500 shadow-sm border-2 border-white dark:border-slate-800"></div>
                        <div class="flex flex-col leading-none gap-1">
                            <span class="text-[10px] font-bold text-slate-400">กำลังชาร์จ</span>
                            <div class="flex items-baseline gap-1">
                                <span class="text-sm font-black text-slate-700 dark:text-slate-200">{{ donutStats.activeCharging }}</span>
                                <span class="text-xs font-bold text-slate-400">({{ activePct | number:'1.0-0' }}%)</span>
                            </div>
                        </div>
                    </div>
                    <!-- Waiting -->
                    <div class="flex items-center gap-3">
                        <div class="w-3.5 h-3.5 rounded-full bg-amber-400 shadow-sm border-2 border-white dark:border-slate-800"></div>
                        <div class="flex flex-col leading-none gap-1">
                            <span class="text-[10px] font-bold text-slate-400">รอชาร์จ</span>
                            <div class="flex items-baseline gap-1">
                                <span class="text-sm font-black text-slate-700 dark:text-slate-200">{{ donutStats.waiting }}</span>
                                <span class="text-xs font-bold text-slate-400">({{ waitingPct | number:'1.0-0' }}%)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Chart & Graph Section -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
            <!-- Chart Section -->
            <div class="animate-fade-in lg:col-span-2 bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 p-6 pb-10 relative overflow-hidden"
                style="animation-delay: 0.25s;">
                <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                    <div>
                        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100">
                            แนวโน้มการชาร์จ (Charging Trends)
                            <span
                                class="text-sm font-medium text-slate-500 dark:text-slate-400 ml-2 bg-slate-100 dark:bg-slate-700 px-2 py-0.5 rounded-full">
                                {{ chartTotalCount }} รายการ
                            </span>
                        </h3>
                        <div class="flex items-center gap-4 text-xs font-medium mt-1">
                            <span class="flex items-center gap-1 "><span
                                    class="w-2 h-2 rounded-full bg-amber-400"></span>
                                <span class="text-slate-600 dark:text-slate-300">{{ chartMode === 'daily' ? 'รายวัน' :
                                    'รายเดือน' }}</span>
                                <span class="text-slate-400 dark:text-slate-500">
                                    @if(chartMode === 'daily' && dailySubMode === 'default') {
                                    ( 7 วันล่าสุด )
                                    }
                                    @if(chartMode === 'daily' && dailySubMode === 'custom') {
                                    ( สูงสุด 10 วัน)
                                    }
                                    @if(chartMode === 'monthly') {
                                    ( {{ selectedMonthStart | date: 'MM/yyyy' }} - {{ selectedMonthEnd | date: 'MM/yyyy'
                                    }}
                                    )
                                    } </span>
                            </span>
                        </div>
                    </div>

                    <!-- Chart Controls -->
                    <div class="flex flex-col items-end gap-2">

                        <!-- Row 1: Inputs & Sub-Modes -->
                        <div class="flex items-center gap-2 min-h-[34px]">

                            <!-- Daily Controls -->
                            <div *ngIf="chartMode === 'daily'" class="flex items-center gap-2">
                                <div
                                    class="flex bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg p-0.5 gap-1">
                                    <button (click)="setDailySubMode('default')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'default' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'">
                                        ทั้งหมด
                                    </button>
                                    <button (click)="setDailySubMode('custom')"
                                        class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                                        [ngClass]="dailySubMode === 'custom' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300'">
                                        กำหนดเอง
                                    </button>
                                </div>

                                <div *ngIf="dailySubMode === 'custom'"
                                    class="flex items-center bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1">
                                    <input type="date" [(ngModel)]="customStartDate" (change)="onCustomDateChange()"
                                        [max]="customEndDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24 [color-scheme:light] dark:[color-scheme:dark]">
                                    <span class="mx-1 text-slate-300 dark:text-slate-600">-</span>
                                    <input type="date" [(ngModel)]="customEndDate" (change)="onCustomDateChange()"
                                        [min]="customStartDate" [max]="maxCustomDate"
                                        class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24 [color-scheme:light] dark:[color-scheme:dark]">

                                    <button (click)="resetCustomDate()"
                                        class="ml-2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-400 hover:text-amber-500 transition-colors"
                                        title="รีเซ็ตเป็น 10 วันล่าสุด">
                                        <span class="material-icons text-[16px]">refresh</span>
                                    </button>
                                </div>
                            </div>

                            <!-- Monthly Inputs -->
                            <div *ngIf="chartMode === 'monthly'"
                                class="flex items-center gap-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg px-2 py-1">
                                <input type="month" [(ngModel)]="selectedMonthStart" (change)="onChartMonthChange()"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] [color-scheme:light] dark:[color-scheme:dark]">
                                <span class="text-slate-300 dark:text-slate-600 mx-1">-</span>
                                <input type="month" [(ngModel)]="selectedMonthEnd" (change)="onChartMonthChange()"
                                    class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px] [color-scheme:light] dark:[color-scheme:dark]">
                            </div>

                        </div>

                        <!-- Row 2: Toggles -->
                        <div class="flex items-center gap-2">
                            <!-- Type Toggle -->
                            <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                                <button (click)="setChartType('line')"
                                    [class]="chartType === 'line' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all" title="Line Chart">
                                    <span class="material-icons text-sm">show_chart</span>
                                </button>
                                <button (click)="setChartType('bar')"
                                    [class]="chartType === 'bar' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="p-1 px-2 rounded-md transition-all" title="Bar Chart">
                                    <span class="material-icons text-sm">bar_chart</span>
                                </button>
                            </div>

                            <!-- Mode Toggle -->
                            <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-lg">
                                <button (click)="setChartMode('daily')"
                                    [class]="chartMode === 'daily' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายวัน</button>
                                <button (click)="setChartMode('monthly')"
                                    [class]="chartMode === 'monthly' ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'"
                                    class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายเดือน</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="relative h-64 w-full">
                    <svg viewBox="0 0 100 100" class="w-full h-full overflow-visible" preserveAspectRatio="none">
                        <defs>
                            <linearGradient id="gradientArea" x1="0" x2="0" y1="0" y2="1">
                                <stop offset="0%" stop-color="#fbbf24" stop-opacity="0.4" />
                                <stop offset="100%" stop-color="#fbbf24" stop-opacity="0" />
                            </linearGradient>
                        </defs>

                        <!-- Grid Lines -->
                        <g class="text-slate-200 dark:text-slate-700/50">
                            <line x1="0" y1="100" x2="100" y2="100" stroke="currentColor" stroke-width="0.5" />
                            <line x1="0" y1="75" x2="100" y2="75" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="25" x2="100" y2="25" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                            <line x1="0" y1="0" x2="100" y2="0" stroke="currentColor" stroke-width="0.5"
                                stroke-dasharray="2" />
                        </g>

                        <!-- Current Area & Line -->
                        <!-- Line Chart -->
                        <g *ngIf="chartType === 'line'">
                            <polygon [attr.points]="currentMonthAreaPoints" fill="url(#gradientArea)"
                                class="opacity-50 transition-all duration-500" />
                            <polyline [attr.points]="currentMonthPoints" fill="none" stroke="#fbbf24" stroke-width="0.5"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="drop-shadow-sm transition-all duration-500" />

                            <!-- Dots (Hover effect) -->
                            <circle *ngFor="let point of currentMonthDots" [attr.cx]="point.x" [attr.cy]="point.y"
                                r="1.5" fill="#fff" stroke="#fbbf24" stroke-width="1"
                                class="opacity-0 hover:opacity-100 transition-opacity cursor-pointer">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </circle>
                        </g>

                        <!-- Bar Chart -->
                        <g *ngIf="chartType === 'bar'">
                            <rect *ngFor="let point of currentMonthDots" [attr.x]="point.x - 2" [attr.y]="point.y"
                                width="4" [attr.height]="100 - point.y" [attr.fill]="point.color"
                                class="hover:opacity-80 hover:fill-yellow-500 border-2 border-white transition-all duration-300 cursor-pointer rx-[1px]">
                                <title>{{ point.label }}: {{ point.value }}</title>
                            </rect>
                        </g>
                    </svg>

                    <!-- Y-Axis Labels (Left Side) -->
                    <div
                        class="absolute inset-y-0 left-[-30px] bottom-2 w-8 flex flex-col justify-between text-[9px] text-yellow-400 font-medium pointer-events-none py-0 items-end pr-1">
                        <span>{{ yAxisLabels[4] }}</span>
                        <span>{{ yAxisLabels[3] }}</span>
                        <span>{{ yAxisLabels[2] }}</span>
                        <span>{{ yAxisLabels[1] }}</span>
                        <span class="translate-y-2">{{ yAxisLabels[0] }}</span>
                    </div>

                    <!-- Dynamic Labels -->
                    <div class="absolute bottom-0 left-0 right-0 translate-y-8 h-8 pointer-events-none">
                        <ng-container *ngFor="let dot of currentMonthDots; let i = index">
                            <div *ngIf="(currentMonthDots.length <= 15) || (i % 5 === 0) || i === 0 || i === currentMonthDots.length - 1"
                                class="absolute top-0 flex flex-col items-center whitespace-nowrap"
                                [style.left.%]="dot.x" style="transform: translateX(-50%);">
                                <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium">{{ dot.label
                                    }}</span>
                                <span *ngIf="dot.subLabel" class="text-[9px] text-slate-400 dark:text-slate-500">{{
                                    dot.subLabel }}</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Recent Activity -->
            <div class="animate-fade-in lg:col-span-1 bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 p-8"
                style="animation-delay: 0.3s;">
                <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 mb-6">รายการล่าสุด</h3>
                <div class="relative">
                    <div class="absolute left-5 top-4 bottom-4 w-0.5 bg-slate-100 dark:bg-slate-700"></div>
                    <div class="space-y-6 relative">
                        <div *ngFor="let item of recentActivity" class="flex items-start gap-4 group">
                            <div class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-amber-600 dark:text-amber-400 text-sm font-bold shadow-sm ring-4 ring-white dark:ring-slate-800 z-10 bg-amber-100 dark:bg-amber-500/20 transition-transform group-hover:scale-110">
                                {{ item.initial }}
                            </div>
                            <div class="flex-1 pt-1">
                                <div class="flex justify-between items-start">
                                    <h5
                                        class="text-sm font-bold text-slate-800 dark:text-slate-200 group-hover:text-amber-500 transition-colors">
                                        {{ item.name }}</h5>
                                    <span
                                        class="text-[10px] font-semibold text-slate-400 dark:text-slate-400 bg-slate-50 dark:bg-slate-700 px-2 py-0.5 rounded-full border border-slate-100 dark:border-slate-600 whitespace-nowrap">{{
                                        item.timeAgo }}</span>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{{ item.info }}</p>
                            </div>
                        </div>
                        <div *ngIf="recentActivity.length === 0"
                            class="text-center text-slate-400 dark:text-slate-500 py-10">
                            <span class="material-icons text-3xl mb-2 opacity-50">history</span>
                            <p class="text-sm">ไม่มีกิจกรรมล่าสุด</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Filter Toggle Button (floating) -->
    <button (click)="toggleMobileFilter()"
        class="md:hidden fixed bottom-6 left-6 z-50 w-14 h-14 bg-amber-400 dark:bg-amber-500 text-white rounded-2xl shadow-xl shadow-amber-200/50 dark:shadow-amber-900/30 flex items-center justify-center hover:bg-amber-500 dark:hover:bg-amber-600 active:scale-95 transition-all animate-float">
        <span class="material-icons text-2xl">tune</span>
        <span *ngIf="activeFilterCount > 0"
            class="absolute -top-1.5 -right-1.5 w-5 h-5 bg-rose-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center shadow-md animate-badge-pop">
            {{ activeFilterCount }}
        </span>
    </button>

    <!-- Mobile Filter Backdrop -->
    <div *ngIf="showMobileFilter" (click)="closeMobileFilter()"
        class="md:hidden fixed inset-0 z-40 bg-black/40 backdrop-blur-sm animate-overlay"></div>

    <!-- Main Content -->
    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden flex flex-col md:flex-row h-full min-h-[600px]  "
        style="animation-delay: 0.35s;">

        <!-- Sidebar Filter -->
        <div class="w-72 md:w-64 border-r border-slate-100 dark:border-slate-700 p-6 bg-slate-50/50 dark:bg-slate-900/30 flex flex-col gap-4 overflow-y-auto custom-scrollbar animate-slide-in-left"
            [ngClass]="{'fixed inset-y-0 left-0 z-50 shadow-2xl': showMobileFilter, 'hidden md:flex': !showMobileFilter}">

            <!-- Sidebar Header -->
            <div class="flex items-center justify-between">
                <h3 class="text-base font-extrabold text-slate-800 dark:text-white flex items-center gap-2">
                    <span class="material-icons text-amber-500 text-lg">filter_list</span> ตัวกรอง
                </h3>
                <div class="flex items-center gap-2">
                    <button *ngIf="activeFilterCount > 0" (click)="clearAllFilters()"
                        class="text-[11px] text-rose-500 hover:text-rose-600 font-bold flex items-center gap-1 px-2 py-1 rounded-lg hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all">
                        <span class="material-icons text-[14px]">clear_all</span> ล้างทั้งหมด
                    </button>
                    <button (click)="closeMobileFilter()"
                        class="md:hidden p-1 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors">
                        <span class="material-icons text-slate-400 dark:text-slate-500">close</span>
                    </button>
                </div>
            </div>

            <!-- Active Filter Summary -->
            <div *ngIf="activeFilterCount > 0"
                class="flex items-center gap-2 px-3 py-2 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-100 dark:border-amber-800/30">
                <span class="material-icons text-amber-500 text-sm">info</span>
                <span class="text-xs text-amber-700 dark:text-amber-400 font-bold">{{ activeFilterCount }}
                    ตัวกรองที่ใช้งาน</span>
            </div>

            <!-- Other Filters (Collapsible) -->
            <div>
                <div (click)="toggleFilterSection('other')"
                    class="flex items-center justify-between mb-3 cursor-pointer select-none group">
                    <h3
                        class="text-sm font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2 group-hover:text-amber-500 transition-colors">
                        <span
                            class="material-icons text-sm text-slate-400 group-hover:text-amber-500 transition-colors">filter_list</span>
                        ตัวกรองอื่นๆ
                        <span *ngIf="showNotExitedOnly || showExitedOnly"
                            class="w-5 h-5 bg-amber-400 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-badge-pop">{{
                            (showNotExitedOnly ? 1 : 0) + (showExitedOnly ? 1 : 0) }}</span>
                    </h3>
                    <span class="material-icons text-slate-400 dark:text-slate-500 text-sm filter-chevron"
                        [class.rotated]="isFilterCollapsed('other')">expand_more</span>
                </div>

                <div class="filter-section-content" [class.collapsed]="isFilterCollapsed('other')"
                    [class.expanded]="!isFilterCollapsed('other')">
                    <label class="flex items-center gap-3 cursor-pointer group p-2 rounded-lg transition-all"
                        [class.bg-emerald-50]="showNotExitedOnly" [class.dark:bg-emerald-900]="showNotExitedOnly"
                        [class.hover:bg-white]="!showNotExitedOnly"
                        [class.dark:hover:bg-slate-800]="!showNotExitedOnly">
                        <div class="relative flex items-center justify-center">
                            <input type="checkbox" [(ngModel)]="showNotExitedOnly" (change)="filterData()"
                                class="peer appearance-none w-5 h-5 border-2 border-slate-300 dark:border-slate-600 dark:bg-slate-800 rounded-md focus:ring-amber-400 checked:bg-amber-400 checked:border-amber-400 transition-all cursor-pointer">
                            <span
                                class="material-icons absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none"
                                style="font-size: 14px;">check</span>
                        </div>
                        <span
                            class="text-sm text-slate-600 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-slate-100 transition-colors font-medium flex items-center gap-1.5">
                            <span class="w-2 h-2 rounded-full bg-emerald-500"></span> ยังไม่ออก (Not Exited)
                        </span>
                    </label>

                    <label class="flex items-center gap-3 cursor-pointer group p-2 rounded-lg transition-all"
                        [class.bg-blue-50]="showExitedOnly" [class.dark:bg-blue-900]="showExitedOnly"
                        [class.hover:bg-white]="!showExitedOnly" [class.dark:hover:bg-slate-800]="!showExitedOnly">
                        <div class="relative flex items-center justify-center">
                            <input type="checkbox" [(ngModel)]="showExitedOnly" (change)="filterData()"
                                class="peer appearance-none w-5 h-5 border-2 border-slate-300 dark:border-slate-600 dark:bg-slate-800 rounded-md focus:ring-amber-400 checked:bg-amber-400 checked:border-amber-400 transition-all cursor-pointer">
                            <span
                                class="material-icons absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none"
                                style="font-size: 14px;">check</span>
                        </div>
                        <span
                            class="text-sm text-slate-600 dark:text-slate-300 group-hover:text-slate-900 dark:group-hover:text-slate-100 transition-colors font-medium flex items-center gap-1.5">
                            <span class="w-2 h-2 rounded-full bg-blue-500"></span> ออกแล้ว (Exited)
                        </span>
                    </label>
                </div>
            </div>

        </div>

        <!-- Table Content -->
        <div class="flex-1 flex flex-col h-[800px]">
            <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col gap-4 bg-white dark:bg-slate-800">
                <!-- Header Row -->
                <div class="flex items-center justify-between">
                    <div class="flex flex-col">
                        <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                            <span class="material-icons text-amber-500">ev_station</span>
                            รายการข้อมูล <span class="text-slate-400 dark:text-slate-500 text-sm font-normal">({{
                                totalItems }}
                                รายการ)</span>
                        </h2>
                        <div class="text-xs text-slate-400 dark:text-slate-500 mt-1" *ngIf="isLoading">กำลังโหลดข้อมูล...
                        </div>
                    </div>

                    <button (click)="showTableFilters = !showTableFilters"
                        class="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold transition-all shadow-sm border"
                        [ngClass]="showTableFilters ? 'bg-amber-50 dark:bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-200 dark:border-amber-500/30' : 'bg-white dark:bg-slate-800 text-slate-500 hover:text-amber-500 border-slate-200 dark:border-slate-700 hover:border-amber-300 dark:hover:border-amber-500/50'">
                        <span class="material-icons text-[18px]">{{ showTableFilters ? 'filter_list_off' : 'filter_list' }}</span>
                        <span class="hidden sm:inline">ตัวกรอง</span>
                    </button>
                </div>

                <!-- Filters Row -->
                <div *ngIf="showTableFilters" class="animate-fade-in flex flex-wrap items-center gap-3 pt-2">

                    <!-- Status Filter Group (Moved from Sidebar) -->
                    <div
                        class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl h-[40px] shadow-sm">
                        <ng-container *ngFor="let status of statusOptions; let last = last">
                            <button (click)="toggleStatus(status.value)"
                                [class]="isStatusChecked(status.value) ? 'bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 shadow-sm font-bold' : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 font-medium'"
                                class="px-3 h-full rounded-lg text-sm transition-all duration-200 ease-in-out flex items-center gap-1.5">
                                <span class="w-2 h-2 rounded-full"
                                    [ngClass]="isStatusChecked(status.value) ? status.color.replace('text-', 'bg-') : 'bg-slate-300 dark:bg-slate-600'"></span>
                                {{ status.label }}
                            </button>
                            <div *ngIf="!last" class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
                        </ng-container>
                    </div>

                    <!-- Min Price Input -->
                    <div class="relative w-full md:w-[130px] h-[40px]">
                        <span
                            class="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 font-bold text-xs">฿</span>
                        <input type="number" placeholder="ค่าบริการขั้นต่ำ" [(ngModel)]="minPrice"
                            (keyup)="filterData()"
                            class="w-full pl-7 pr-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-600 dark:text-slate-300 focus:bg-white dark:focus:bg-slate-800 focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-900/40 transition-all placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none h-full">
                    </div>



                    <!-- Search Group (Dropdown + Input) -->
                    <div
                        class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-900/40 transition-all overflow-visible w-full md:w-[320px] relative z-30 h-[40px] md:ml-auto">

                        <!-- Search Type Dropdown -->
                        <div class="relative min-w-[120px] border-r border-slate-200 dark:border-slate-700 h-full">
                            <button (click)="toggleSearchTypeDropdown()"
                                class="w-full pl-3 pr-2 h-full text-sm font-bold text-slate-600 dark:text-slate-300 flex items-center justify-between hover:text-amber-600 dark:hover:text-amber-500 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-l-xl transition-all focus:outline-none">
                                <span class="truncate">{{ currentSearchTypeLabel }}</span>
                                <span
                                    class="material-icons text-sm text-slate-400 dark:text-slate-500 transition-transform duration-200"
                                    [ngClass]="{'rotate-180': isSearchTypeDropdownOpen}">expand_more</span>
                            </button>

                            <!-- Backdrop -->
                            <button *ngIf="isSearchTypeDropdownOpen" class="fixed inset-0 cursor-default z-40"
                                (click)="toggleSearchTypeDropdown()"></button>

                            <!-- Dropdown Menu -->
                            <div *ngIf="isSearchTypeDropdownOpen"
                                class="absolute top-full mt-2 left-0 w-[160px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-50 overflow-hidden animation-fade-in-up">
                                <button (click)="selectSearchType('licensePlate')"
                                    class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                    <span
                                        class="material-icons text-lg text-slate-400 dark:text-slate-500">directions_car</span>
                                    ทะเบียนรถ
                                </button>
                                <button (click)="selectSearchType('siteName')"
                                    class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                    <span
                                        class="material-icons text-lg text-slate-400 dark:text-slate-500">location_on</span>
                                    ชื่อสถานที่
                                </button>
                                <button (click)="selectSearchType('spaceCode')"
                                    class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-colors flex items-center gap-2">
                                    <span
                                        class="material-icons text-lg text-slate-400 dark:text-slate-500">grid_view</span>
                                    รหัสช่องจอด
                                </button>
                            </div>
                        </div>

                        <!-- Search Input -->
                        <div class="relative flex-1 h-full">
                            <span
                                class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 dark:text-slate-500 text-xl">search</span>
                            <input type="text" [placeholder]="'ค้นหา' + currentSearchTypeLabel + '...'"
                                [(ngModel)]="searchText" (keyup)="filterData()"
                                class="w-full pl-10 pr-4 h-full bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-500 rounded-r-xl">
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-1 overflow-auto custom-scrollbar relative">
                <table class="w-full text-sm text-left text-slate-600 dark:text-slate-300">
                    <thead
                        class="text-xs text-slate-500 dark:text-slate-400 uppercase bg-slate-50/95 dark:bg-slate-900/95 sticky top-0 z-10 backdrop-blur-sm border-b border-slate-200 dark:border-slate-700">
                        <tr>
                            <th (click)="sortData('siteName')"
                                class="px-6 py-4 font-bold cursor-pointer hover:text-slate-700 dark:hover:text-slate-200 transition-colors group">
                                <div class="flex items-center gap-1">
                                    สถานที่ / ช่องจอด
                                    <span
                                        class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                        [class.opacity-100]="sortColumn === 'siteName'">
                                        {{ sortColumn === 'siteName' && sortDirection === 'asc' ? 'arrow_upward' :
                                        'arrow_downward' }}
                                    </span>
                                </div>
                            </th>
                            <th (click)="sortData('licensePlate')"
                                class="px-6 py-4 font-bold cursor-pointer hover:text-slate-700 dark:hover:text-slate-200 transition-colors group">
                                <div class="flex items-center gap-1">
                                    ทะเบียนรถ
                                    <span
                                        class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                        [class.opacity-100]="sortColumn === 'licensePlate'">
                                        {{ sortColumn === 'licensePlate' && sortDirection === 'asc' ? 'arrow_upward' :
                                        'arrow_downward' }}
                                    </span>
                                </div>
                            </th>
                            <th class="px-6 py-4 font-bold">ลูกค้า</th>
                            <th (click)="sortData('enterAt')"
                                class="px-6 py-4 font-bold cursor-pointer hover:text-slate-700 dark:hover:text-slate-200 transition-colors group">
                                <div class="flex items-center gap-1">
                                    เวลาเข้า - ออก
                                    <span
                                        class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                        [class.opacity-100]="sortColumn === 'enterAt'">
                                        {{ sortColumn === 'enterAt' && sortDirection === 'asc' ? 'arrow_upward' :
                                        'arrow_downward' }}
                                    </span>
                                </div>
                            </th>
                            <th (click)="sortData('totalTime')"
                                class="px-6 py-4 font-bold text-center cursor-pointer hover:text-slate-700 dark:hover:text-slate-200 transition-colors group">
                                <div class="flex items-center justify-center gap-1">
                                    ระยะเวลา
                                    <span
                                        class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                        [class.opacity-100]="sortColumn === 'totalTime'">
                                        {{ sortColumn === 'totalTime' && sortDirection === 'asc' ? 'arrow_upward' :
                                        'arrow_downward' }}
                                    </span>
                                </div>
                            </th>
                            <th (click)="sortData('price')"
                                class="px-6 py-4 font-bold text-center cursor-pointer hover:text-slate-700 dark:hover:text-slate-200 transition-colors group">
                                <div class="flex items-center justify-center gap-1">
                                    ค่าบริการ
                                    <span
                                        class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                        [class.opacity-100]="sortColumn === 'price'">
                                        {{ sortColumn === 'price' && sortDirection === 'asc' ? 'arrow_upward' :
                                        'arrow_downward' }}
                                    </span>
                                </div>
                            </th>
                            <th (click)="sortData('status')"
                                class="px-6 py-4 font-bold text-center cursor-pointer hover:text-slate-700 dark:hover:text-slate-200 transition-colors group">
                                <div class="flex items-center justify-center gap-1">
                                    สถานะ
                                    <span
                                        class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                        [class.opacity-100]="sortColumn === 'status'">
                                        {{ sortColumn === 'status' && sortDirection === 'asc' ? 'arrow_upward' :
                                        'arrow_downward' }}
                                    </span>
                                </div>
                            </th>
                            <th class="px-6 py-4 font-bold text-center">จัดการ</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-slate-100 dark:divide-slate-700/50 text-sm">
                        <tr *ngFor="let item of transactions; let i = index"
                            class="animate-table-row hover:bg-amber-50/30 dark:hover:bg-slate-700/50 transition-colors group duration-200 even:bg-slate-50/30 dark:even:bg-slate-800/40"
                            [style.animation-delay.ms]="i * 40">

                            <!-- Site & Space -->
                            <td class="px-6 py-4 align-middle">
                                <div class="flex flex-col gap-1">
                                    <div class="flex items-center gap-2">
                                        <span
                                            class="inline-flex items-center px-2.5 py-0.5 rounded-md text-[10px] font-bold bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 border border-slate-200/60 dark:border-slate-600/60 uppercase tracking-wide">
                                            {{ item.spaceCode }}
                                        </span>
                                    </div>
                                    <span
                                        class="font-extrabold text-slate-700 dark:text-slate-200 text-[14px] group-hover:text-amber-600 dark:group-hover:text-amber-400 transition-colors line-clamp-1"
                                        [title]="item.siteName">{{
                                        item.siteName }}</span>

                                    <span class="text-[11px] text-slate-400 dark:text-slate-500">{{ item.siteEv
                                        }}</span>
                                </div>
                            </td>

                            <!-- License Plate -->
                            <td class="px-6 py-4 align-middle">
                                <div class="group/edit relative  w-fit">
                                    <div
                                        class="inline-flex items-center gap-2 bg-yellow-50 dark:bg-amber-900/20 border border-yellow-200 dark:border-amber-800/50 min-w-[100px] rounded-xl px-2 py-1 transition-all duration-300 group-hover/edit:bg-white dark:group-hover/edit:bg-slate-800 group-hover/edit:border-amber-300 dark:group-hover/edit:border-amber-600 group-hover/edit:shadow-lg group-hover/edit:shadow-amber-100/50 dark:group-hover/edit:shadow-amber-900/30 group-hover/edit:-translate-y-0.5">
                                        <div class="flex items-center gap-1.5">
                                            <span
                                                class="material-icons text-[14px] text-yellow-400 dark:text-amber-500 group-hover/edit:text-amber-500 dark:group-hover/edit:text-amber-400 transition-colors">directions_car</span>
                                            <span
                                                class="font-display font-black text-yellow-700 dark:text-amber-500 text-xs tracking-wide group-hover/edit:text-yellow-900 dark:group-hover/edit:text-amber-400 transition-colors">
                                                {{ item.licensePlate || '-' }}
                                            </span>
                                        </div>
                                        <div *ngIf="!item.exitAt"
                                            class="w-[1px] h-3 bg-yellow-200 dark:bg-amber-800 group-hover/edit:bg-amber-100 dark:group-hover/edit:bg-amber-700 transition-colors mx-0.5">
                                        </div>
                                        <span *ngIf="!item.exitAt"
                                            (click)="openLicenseEditModal(item); $event.stopPropagation()"
                                            style="font-size: 18px;"
                                            class="cursor-pointer material-icons text-yellow-300 dark:text-amber-600 group-hover/edit:text-amber-500 dark:group-hover/edit:text-amber-400 transition-colors scale-90 group-hover/edit:scale-110">edit</span>
                                    </div>
                                </div>
                            </td>

                            <!-- User -->
                            <td class="px-6 py-4 align-middle">
                                <div class="flex items-center gap-3">
                                    <div
                                        class="w-8 h-8 rounded-full flex items-center justify-center bg-slate-100 dark:bg-slate-700 text-slate-400 dark:text-slate-500 border border-slate-200/50 dark:border-slate-600/50">
                                        <span class="material-icons text-lg">person</span>
                                    </div>
                                    <div class="flex flex-col">
                                        <span class="font-bold text-slate-700 dark:text-slate-300 text-xs">
                                            {{ item.activate ? 'สมาชิก' : '-' }}
                                        </span>
                                        <span class="text-[10px] text-slate-400 dark:text-slate-500">
                                            {{ item.activate ? 'มีเจ้าของ' : '-' }}
                                        </span>
                                    </div>
                                </div>
                            </td>

                            <!-- Time -->
                            <td class="px-6 py-4 align-middle">
                                <div class="flex flex-col gap-1.5 min-w-[120px]">
                                    <div class="flex items-center gap-2 text-xs">
                                        <div class="w-1.5 h-1.5 rounded-full bg-emerald-400"></div>
                                        <span class="font-bold text-slate-600 dark:text-slate-300 font-display">{{
                                            formatDateDisplay(item.enterAt?.toString() || '') }}</span>
                                    </div>
                                    <div class="flex items-center gap-2 text-xs">
                                        <div class="w-1.5 h-1.5 rounded-full bg-rose-400"></div>
                                        <span class="font-bold text-slate-600 dark:text-slate-300 font-display"
                                            *ngIf="item.exitAt">{{
                                            formatDateDisplay(item.exitAt.toString()) }}</span>
                                        <span class="text-slate-300 dark:text-slate-500 italic"
                                            *ngIf="!item.exitAt">ยังไม่ระบุ</span>
                                    </div>
                                </div>
                            </td>

                            <!-- Duration -->
                            <td class="px-6 py-4 align-middle text-center">
                                <span *ngIf="item.totalTime > 0"
                                    class="inline-block text-slate-600 dark:text-slate-300 font-bold bg-slate-100/50 dark:bg-slate-700/50 px-2.5 py-1 rounded-lg border border-slate-200/50 dark:border-slate-600/50 text-xs shadow-sm">
                                    {{ calculateTime(item.totalTime) }}
                                </span>
                                <span *ngIf="!item.totalTime || item.totalTime === 0"
                                    class="text-slate-300 dark:text-slate-600 text-xl">-</span>
                            </td>

                            <!-- Price -->
                            <td class="px-6 py-4 align-middle text-center">
                                <div class="font-black text-slate-800 dark:text-slate-200 text-[15px] tracking-tight">
                                    {{ item.price | number:'1.2-2' }} <span
                                        class="text-[10px] text-slate-400 dark:text-slate-500 font-normal">฿</span>
                                </div>
                            </td>

                            <!-- Status -->
                            <td class="px-1 py-4 align-middle text-center w-[150px]">
                                <div class="inline-flex items-center gap-1.5">
                                    <div class="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-[11px] font-bold ring-1 ring-inset transition-all"
                                        [ngClass]="getStatusClass(item.status, item.exitAt)">
                                        <span class="w-1.5 h-1.5 rounded-full bg-current"></span>
                                        {{ getStatusLabel(item.status, item.exitAt) }}
                                    </div>
                                    <!-- Plug icon — shown only when isReady -->
                                    <span *ngIf="item.isReady"
                                        class="material-icons text-emerald-500 dark:text-emerald-400 cursor-default select-none"
                                        style="font-size: 16px;" title="เสียบหัวชาร์จอยู่">power</span>
                                </div>
                            </td>

                            <!-- Manage -->
                            <td class="px-6 py-4 align-middle text-center">
                                <button (click)="openDetailModal(item)"
                                    class="cursor-pointer inline-flex items-center justify-center w-9 h-9 rounded-xl bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-400 dark:text-slate-500 hover:text-amber-500 dark:hover:text-amber-400 hover:border-amber-300 dark:hover:border-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/30 hover:shadow-md hover:-translate-y-0.5 transition-all shadow-sm hover-lift"
                                    title="ดูรายละเอียด">
                                    <span class="material-icons text-[20px]">visibility</span>
                                </button>
                            </td>
                        </tr>

                        <!-- Empty State -->
                        <tr *ngIf="totalItems === 0 && !isLoading">
                            <td colspan="8"
                                class="px-6 py-24 text-center text-slate-400 dark:text-slate-500 bg-slate-50/30 dark:bg-slate-800/30 border-2 border-dashed border-slate-100 dark:border-slate-700 rounded-b-3xl h-[calc(100vh-377px)]">
                                <div class="flex flex-col items-center gap-4 animate-fade-in">
                                    <div
                                        class="w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center border border-slate-200 dark:border-slate-700">
                                        <span
                                            class="material-icons text-3xl text-slate-300 dark:text-slate-600">ev_station</span>
                                    </div>
                                    <div class="flex flex-col">
                                        <span
                                            class="font-bold text-slate-600 dark:text-slate-400 text-lg">ไม่พบข้อมูลการชาร์จ</span>
                                        <span class="text-sm">ลองปรับตัวกรองหรือคำค้นหาใหม่</span>
                                    </div>
                                    <button (click)="onRefresh()"
                                        class="mt-2 px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-sm rounded-lg text-sm font-bold text-slate-600 dark:text-slate-400 hover:text-amber-500 dark:hover:text-amber-400 hover:border-amber-300 dark:hover:border-amber-600 transition-all">
                                        ล้างตัวกรองทั้งหมด
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination Footer -->
            <div
                class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
                <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
                    <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }}
                        รายการ</span>
                    <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
                        class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/40 focus:border-amber-400 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors shadow-sm focus:shadow-md">
                        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
                    </select>
                </div>

                <div class="flex items-center gap-2">
                    <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
                        class="w-9 h-9 flex items-center justify-center rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400 shadow-sm">
                        <span class="material-icons text-sm">chevron_left</span>
                    </button>

                    <button *ngFor="let page of pagesArray" (click)="onPageChange(page)"
                        class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all shadow-sm"
                        [ngClass]="page === currentPage ? 'bg-amber-400 text-white shadow-lg shadow-amber-200 dark:shadow-amber-900/30' : 'bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 dark:hover:text-amber-400'">
                        {{ page }}
                    </button>

                    <button (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages"
                        class="w-9 h-9 flex items-center justify-center rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400 shadow-sm">
                        <span class="material-icons text-sm">chevron_right</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <app-modal-ev-charger-detail [isOpen]="isDetailModalOpen" [data]="selectedTransaction"
        (onClose)="closeDetailModal()">
    </app-modal-ev-charger-detail>

    <app-modal-ev-charger-license-edit [isOpen]="isLicenseEditModalOpen" [data]="selectedLicenseEditData"
        (onClose)="closeLicenseEditModal()" (onSave)="onLicenseSaved($event)">
    </app-modal-ev-charger-license-edit>